import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()

export class HttpinterceptorService implements HttpInterceptor {
  constructor(private loaderService: NgxSpinnerService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loaderService.show();
    const auth_token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InBhcHBpZSIsIlVzZXJJRCI6IjBmZmI4MDkzLWRkZmItNDFiNS1hMjJiLWIyMzA5ZDRlZDc4YyIsIkVtYWlsSUQiOiJ0ZXN0QHR2c25leHQuaW8iLCJuYmYiOjE1NTYyODE4MzgsImV4cCI6MTU1NzE0NTgzOCwiaWF0IjoxNTU2MjgxODM4fQ.KwPjeuEP_B41X5r6y0kZkBQ5gjQDvoq5W6Ra1BQVmL4';
    var reqcloned = req.clone({
      setHeaders: {
        "Authorization": "bearer " + auth_token
      }
    });
    return next.handle(reqcloned).map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        setTimeout(() => {
          this.loaderService.hide()
        }, 300);
        // console.log('event--->>>', event);
      }
      return event;
    });
  }
}
